module.exports = __webpack_public_path__ + "static/img/car_13_7_cold@3x.4e07d400.png";